import $ from 'jquery';
import Swiper from 'swiper/bundle';

// init Swiper:
const news_swiper = new Swiper('.news-swiper', {

    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    speed: 800,
    autoHeight: true,
    //spaceBetween: 20,
  
    // Navigation arrows
    navigation: {
        nextEl: ".news-swiper-button-next",
        prevEl: ".news-swiper-button-prev",
    },
});

//export default news_swiper;


// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/news-slider.js